import React, { useEffect, useState } from "react";
import { Box, InputLabel } from "@mui/material";

const PatientDetails = (props) => {
  const { patienDetails } = props;

  const { PatientDetails } = patienDetails || {};

  const [details, setDetails] = useState([]);

  const compareValue = [
    "national_id",
    "patient_first_name",
    "patient_middle_name",
    "education_level",
    "dob",
    "patient_last_name",
    "sex",
    "patient_region",
    "marital_status",
    "ethnicity",
    "client_is_handicapped",
    "country_of_origin",
    "current_residential_address",
    "permanent_residential_address",
    "disability",
    "inkhundla",
    "chiefdom",
    "postal_address",
    "secondary_cellphone",
    "primary_cellphone",
    "land_phone",
    "CMIS_id",
    "patient_code",
    "nurse_name",
    "nurse_id",
    "patient_email_id",
    "land_phone",
    "occupation",
    "year",
  ];
  const customKeyName = {
    national_id: "National ID",
    patient_first_name: "First Name",
    patient_last_name: "Last Name",
    patient_middle_name: "Middle Name",
    dob: "Date of Birth",
    sex: "Sex",
    patient_region: "Region",
    marital_status: "Marital Status",
    ethnicity: "Ethnicity",
    client_is_handicapped: "Handicapped",
    education_level: "Education Level",
    country_of_origin: "Country of Origin",
    current_residential_address: "Current Residential Address",
    permanent_residential_address: "Permanent Residential Address",
    disability: "Disability",
    inkhundla: "Inkhundla",
    chiefdom: "Chiefdom",
    postal_address: "Postal Address",
    secondary_cellphone: "Secondary Cellphone",
    primary_cellphone: "Primary Cellphone",
    land_phone: "Land Phone",
    CMIS_id: "CMIS ID",
    patient_code: "Patient Code",
    nurse_name: "Nurse Name",
    nurse_id: "Nurse ID",
    patient_email_id: "Patient Email ID",
    occupation: "Occupation",
    year: "Year",
  };

  useEffect(() => {
    if (Object.keys(PatientDetails).length > 0) {
      let details = [];
      Object.keys(PatientDetails).forEach((item) => {
        if (
          PatientDetails.hasOwnProperty(item) &&
          item !== "id" &&
          item !== "deletedAt" &&
          item !== "createdAt" &&
          item !== "updatedAt" &&
          item !== "question1" &&
          item !== "question2" &&
          item !== "question3"
        ) {
          const keyName = compareValue?.includes(item)
            ? customKeyName[item]
            : item;
          details.push({ [keyName]: PatientDetails[item] });
        }
      });
      setDetails(details);
    }
  }, [PatientDetails]);

  return (
    <>
      {Boolean(details.length) &&
        details.map((item, index) => (
          <Box
            key={index}
            sx={{ display: "inline-flex", gap: "0.3rem", alignItems: "center" }}
          >
            <InputLabel
              sx={{
                color: "#000",
                fontWeight: "bold",
              }}
            >
              {Object.keys(item)[0]} :
            </InputLabel>
            <InputLabel sx={{ color: (theme) => theme.palette.grey[800], textTransform: "capitalize" }}>
              {item[Object.keys(item)[0]]?.replace(/_/g, ' ')}
            </InputLabel>
          </Box>
        ))}
    </>
  );
};

export default PatientDetails;
